import React from "react";
import PropTypes from "prop-types";

import "./Select.css";

const Select = (props) => {
  Select.propTypes = {
    children: PropTypes.any,
    type: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    dataHandler: PropTypes.func,
    className: PropTypes.string,
  };

  return (
    <div
      className={
        props.className
          ? `${props.className} select-container`
          : "select-container"
      }
      style={{ width: props.type === "fill" ? "100%" : props.type }}>
      {props.children}
    </div>
  );
};

export default Select;
